import { STORAGE_KEYS } from '@/constants/storage';

/** Remove legacy auth artifacts from browser storage (tokens, user profile, permission caches). */
const LEGACY_KEYS = [
  STORAGE_KEYS.ACCESS_TOKEN,
  STORAGE_KEYS.REFRESH_TOKEN,
  STORAGE_KEYS.ENABLED_FEATURES,
  'fattahone_user',
  'fattah_enabled_modules',
  'fattah_accessible_modules',
  'fattah_force_password_change',
  // Legacy product names
  'fattahone_access_token',
  'fattahone_refresh_token',
  'fattahone_user',
  'fattahone_enabled_features',
  'fattahone_enabled_modules',
];

export function purgeLegacyAuthFromBrowser(): void {
  for (const key of LEGACY_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  }
}
